import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Loader, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function Faqs() {
  const nav = useNavigate();
  const [faqs, setFaqs] = useState(null);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);
  return (
    <div className="max-w-3xl mx-auto">
      <Button variant="ghost" className="rounded-full mb-4 -ml-2" onClick={() => nav("/")} data-testid="faqs-back"><ArrowLeft className="w-4 h-4 mr-1.5" /> Home</Button>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold text-center mb-8">Frequently Asked Questions</h1>
      {!faqs ? <Loader /> : faqs.length === 0 ? (
        <EmptyState icon={HelpCircle} title="FAQs coming soon" description="We're putting together answers to common questions." testId="faqs-page-empty" />
      ) : (
        <Accordion type="single" collapsible className="space-y-3" data-testid="faqs-accordion">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="bg-white border border-border rounded-2xl px-5">
              <AccordionTrigger className="text-left font-medium hover:no-underline">{f.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </div>
  );
}
